//
//
//
//
//
//

import Tooltip from '@/mixins/tooltip';

export default {
  name: 'DpTooltip',
  mixins: [Tooltip],
};
